export const GET_ASSETS_LIST = "GET_ASSETS_LIST";
export const ASSETS_API_START = "ASSETS_API_START";
export const GET_SELECTED_ASSETS_LIST = "GET_SELECTED_ASSETS_LIST";
export const IS_ASSET_CREATE = "IS_ASSET_CREATE";
export const IS_ASSET_LIST = "IS_ASSET_LIST";
export const GET_SELECTED_ASSETS_SUB_CATEGORY =
  "GET_SELECTED_ASSETS_SUB_CATEGORY";
export const IS_ASSET_EDIT = "IS_ASSET_EDIT";
export const GET_ASSET_NAME = "GET_ASSET_NAME";
